import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import {
  ButtonComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tellent-assistant-header',
  standalone: true,
  imports: [IconButtonComponent, ButtonComponent, HeadingComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-icon-button variant="plain" iconName="menu" size="small" (click)="menu.emit()" />
    @if (inThread()) {
      <rt-heading variant="subheading" class="title">{{ title() }}</rt-heading>
      <rt-button size="small" variant="tertiary" (click)="newChat.emit()">
        <rt-icon name="edit-square" />
        New
      </rt-button>
    }
    <rt-icon-button
      variant="plain"
      iconName="close"
      size="small"
      class="close"
      [class.close-solo]="!inThread()"
      (click)="close.emit()"
    />
  `,
  styleUrls: ['./tellent-assistant-header.component.less'],
})
export class TellentAssistantHeaderComponent {
  public readonly title = input.required<string>();
  public readonly inThread = input.required<boolean>();

  public readonly menu = output<void>();
  public readonly newChat = output<void>();
  public readonly close = output<void>();
}
